import { render, staticRenderFns } from "./Our-shares.vue?vue&type=template&id=c91b380c&"
import script from "./Our-shares.vue?vue&type=script&lang=js&"
export * from "./Our-shares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports